
import { RevRating } from '@ds/components/Rating'

import translations from './Row.translations'
import { formatBytes } from './Table.helpers'

export default {
  components: {
    RevRating,
  },

  props: {
    cells: {
      type: Array,
      required: true,
    },
  },

  computed: {
    translations: () => translations,
    valuesExist() {
      // Only display a line if all values to display exist
      const cellsDataPresence = this.cells.map((cell) => cell.value !== null)
      const areAllValuesDefined = !cellsDataPresence.includes(false)

      return areAllValuesDefined
    },
    rowLabelId() {
      return this.cells[0].label
    },
    cleanCells() {
      return this.cells.map(({ ...cellData }) => ({
        formattedValue: this.formattedValue(cellData.value, cellData.unit),
        value: parseFloat(cellData.value),
        maxValue: cellData.maxValue,
        total: cellData.total,
      }))
    },
    rowTitle() {
      return Object.values(translations).find(
        ({ id }) => id === this.rowLabelId,
      )
    },
    isAverageRating() {
      return this.rowLabelId === 'product_comparison_reviews_global_label'
    },
    isValueForMoney() {
      return (
        this.rowLabelId ===
        'product_comparison_reviews_characteristics_review_main'
      )
    },
    isBatteryCapacity() {
      return (
        this.rowLabelId ===
        'product_comparison_characteristics_battery_capacity'
      )
    },
    isOtherCell() {
      return (
        !this.isAverageRating &&
        !this.isValueForMoney &&
        !this.isBatteryCapacity
      )
    },
  },

  methods: {
    formattedValue(value, unit) {
      if (typeof value === 'boolean') {
        return value
          ? this.$t(translations.characteristicsBooleanYes)
          : this.$t(translations.characteristicsBooleanNo)
      }
      if (unit === 'bytes') {
        return formatBytes(value)
      }

      return unit ? `${value} ${unit}` : value
    },
    percentageOf(value, maxValue) {
      return Math.round((value / maxValue) * 100)
    },
    getProgressColor(index) {
      return index === 0 ? '#CAB3FA' : '#77C4BB'
    },
  },
}
